import axios from "../lib/axios";

//list find one
export const getAllLink = () => {
  return axios.get(`/all-link`);
};
//link create
export const createShortLink = (dataLink) => axios.post(`/add-link`, dataLink);
//link detail
export const getDetailShortLink = (shortId) =>
  axios.get(`/find-link/${shortId}`);

export const deleteShortLink = (shortId) => {
  return axios.delete(`/delete-link`, {
    data: {
      id: shortId,
    },
  });
};
